import type { ClientPrioritySegment, ProducerBehaviorProfile, SupportedCulture } from '../types';

interface InputPanelProps {
  producerProfile: ProducerBehaviorProfile;
  onProducerProfileChange: (value: ProducerBehaviorProfile) => void;
  clientPrioritySegment: ClientPrioritySegment;
  onClientPrioritySegmentChange: (value: ClientPrioritySegment) => void;
  culture: SupportedCulture;
  onCultureChange: (value: SupportedCulture) => void;
  value: string;
  onChange: (value: string) => void;
}

const PROFILE_OPTIONS: Array<{ value: ProducerBehaviorProfile; label: string }> = [
  { value: 'analitico', label: 'Analítico' },
  { value: 'diretivo', label: 'Diretivo' },
  { value: 'integrador', label: 'Integrador' },
  { value: 'expressivo', label: 'Expressivo' }
];

const CLIENT_SEGMENT_OPTIONS: Array<{ value: ClientPrioritySegment; label: string }> = [
  { value: 'avaliar', label: 'Avaliar' },
  { value: 'conquistar', label: 'Conquistar' },
  { value: 'incentivar', label: 'Incentivar' },
  { value: 'blindar', label: 'Blindar' }
];

const CULTURE_OPTIONS: Array<{ value: SupportedCulture; label: string }> = [
  { value: 'algodao', label: 'Algodão' },
  { value: 'arroz', label: 'Arroz' },
  { value: 'banana', label: 'Banana' },
  { value: 'batata', label: 'Batata' },
  { value: 'cafe', label: 'Café' },
  { value: 'cana', label: 'Cana-de-açúcar' },
  { value: 'cebola', label: 'Cebola' },
  { value: 'cevada', label: 'Cevada' },
  { value: 'citros', label: 'Citros' },
  { value: 'feijao', label: 'Feijão' },
  { value: 'frutas', label: 'Frutas' },
  { value: 'hortifruti', label: 'Hortifruti' },
  { value: 'milho', label: 'Milho' },
  { value: 'outra', label: 'Outra' },
  { value: 'pastagem', label: 'Pastagem' },
  { value: 'sorgo', label: 'Sorgo' },
  { value: 'soja', label: 'Soja' },
  { value: 'tomate', label: 'Tomate' },
  { value: 'trigo', label: 'Trigo' },
  { value: 'uva', label: 'Uva' },
  { value: 'vegetais', label: 'Vegetais' },
];

export const InputPanel = ({
  producerProfile,
  onProducerProfileChange,
  clientPrioritySegment,
  onClientPrioritySegmentChange,
  culture,
  onCultureChange,
  value,
  onChange
}: InputPanelProps) => {
  const charCount = value.trim().length;

  return (
    <section className="panel panel--input">
      <div className="panel__selectors">
        <div className="panel__field">
          <label htmlFor="producer-profile" className="panel__label">
            Perfil do produtor
          </label>
          <select
            id="producer-profile"
            className="panel__select"
            value={producerProfile}
            onChange={(event) => onProducerProfileChange(event.target.value as ProducerBehaviorProfile)}
          >
            {PROFILE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <div className="panel__field">
          <label htmlFor="client-segment" className="panel__label">
            Segmentação e priorização
          </label>
          <select
            id="client-segment"
            className="panel__select"
            value={clientPrioritySegment}
            onChange={(event) => onClientPrioritySegmentChange(event.target.value as ClientPrioritySegment)}
          >
            {CLIENT_SEGMENT_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <div className="panel__field">
          <label htmlFor="culture-input" className="panel__label">
            Cultura
          </label>
          <select
            id="culture-input"
            className="panel__select"
            value={culture}
            onChange={(event) => onCultureChange(event.target.value as SupportedCulture)}
          >
            {CULTURE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="panel__heading-row">
        <label htmlFor="scenario-input" className="panel__label">
          Descreva o cenário da reunião
        </label>
        <span className="panel__counter">{charCount} caracteres úteis</span>
      </div>
      <textarea
        id="scenario-input"
        className="panel__textarea"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={`Exemplo: Renegociação com produtor de soja (2.800 ha).
Cliente focado em preço por hectare.
Temos evidência de ganho em estabilidade produtiva.
Participam produtor, gerente financeiro e agrônomo.`}
      />
      <p className="panel__helper">
        Inclua contexto da fazenda, decisor, safra, pressão competitiva e objetivo do encontro. Quanto mais detalhes você trouxer, melhor será a preparação.
      </p>
    </section>
  );
};
